import React from "react";
import styled, { css } from "styled-components";
import { rem, transparentize } from "polished";
import Button from "../../../Button";
import clsx from "clsx";
import { IconClose } from "../../../Icons/IconClose";


const ItemActionHandle = ({
  className = '',
  image,
  title,
  itemEvent,
  removeEvent
}) => {
  const isProductionUrl =
    process.env.NODE_ENV === "production" ? "/builderonly/" : "/";
  return <EventHeaderLayout className={clsx("pattern", className)} onClick={itemEvent}>
    <div
      className="image"
    >
      {image && <img src={image} alt={title || ''} width={60} />}
    </div>
    <h6 className="title">
      {title}
    </h6>
    <div className="remove">
        {removeEvent ? <IconClose
          onClick={(e) => {
            e.stopPropagation();
            removeEvent();
          }}
        /> : <img src={`${isProductionUrl}arrow.svg`} alt={title || ''} width={60} />}
      </div>
  </EventHeaderLayout>
};
export default ItemActionHandle;

const EventHeaderLayout = styled.div`
  ${({ theme }) => css`
    &.pattern {
      margin-bottom: ${rem(20)};
      display: grid;
      grid-template-columns: 60px 1fr;
      gap: 20px;
      align-items: center;
      background-color: ${theme.colors.white};;
      border-radius: 30px;
      padding:20px 15px;
      cursor: pointer;
      position: relative;

      .image {
        max-width: 100%;
      }

      .title {
        flex-grow: 1;
        font-size: ${rem(14)};
        position: relative;
        padding-right: 30px;
      }
       .remove {
          font-size: ${rem(20)};
          font-weight: normal;
          position: absolute;
          top: 50%;
          right: 10px;
          transform: translateY(-50%);
          z-index: 1;

          img {
            height: 50px;
          }
        }
    }
  `}
`;
